    <template>
  <v-row align="center" justify="center">
    <div class="certificate-card">
    <v-col class="col-12  col-md-5">
    
      <div class="certificate-image">
          <img src="@/assets/img/introduceList2.jpg" />
        </div>
        
      </v-col>
    </div>
    <div class="certificate-card">
    <v-col class="col-12  col-md-5">
    
      <div class="certificate-image align-self-center">
          <img src="@/assets/img/introduceList1.jpg" />
        </div>
     
      </v-col>
      </div>
    

    <div class="certificate-card">
    <v-col class="col-12  col-md-3">
      <div class="certificate-image2">
          <img src="@/assets/img/introduceList3.jpg" />
        </div>
    </v-col>
  </div>
  <div class="certificate-card">
    <v-col class="col-12  col-md-3">
      <div class="certificate-image2">
          <img src="@/assets/img/introduceList4.jpg" />
        </div>
      </v-col>
      </div>
     
      <div class="certificate-card">
    <v-col class="col-12  col-md-3">
      
      <div class="certificate-image2">
          <img src="@/assets/img/introduceList5.jpg" />
        </div>
      </v-col>
      </div>
      
  </v-row>
</template>

    <script>
export default {
  name: "introduceList",
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  color: #333;
  line-height: 1.6;
  min-height: 100vh;
  padding: 20px;
}

#introduceList {
  max-width: 1200px;
  margin: 0 auto;
}

.certificate-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
}

.certificate-card {
  max-width: 100%;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  position: relative;
  align-items: center;
  padding: 30px;
  margin: 20px;
}

.certificate-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.certificate-image {
  /* max-width: 100%; */

  align-items: center;
  /* overflow: hidden; */
  position: relative;
  /* padding-right: 50px; */
}
.certificate-image2 {
  /* max-width: 100%; */
  align-items: center;
  /* overflow: hidden; */
  position: relative;
  /* padding-right: 50px; */
  /* padding-top: 50px; */
}

.certificate-image img {
  /* width: 100%; */
  /* object-fit: cover; */
  transition: transform 0.5s ease;
  /* padding: 30px; */
 
}
.certificate-image2 img {
  /* object-fit: cover; */
  transition: transform 0.5s ease;
  /* padding: 30px; */
}

.certificate-card:hover .certificate-image img {
  transform: scale(1.05);
}
.certificate-card:hover .certificate-image2 img {
  transform: scale(1.05);
}

.certificate-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #e74c3c;
  color: white;
  padding: 5px 12px;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 600;
}

.certificate-content {
  padding: 0px;
}




.no-results {
  text-align: center;
  grid-column: 1 / -1;
  padding: 50px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.no-results i {
  font-size: 3rem;
  color: #ddd;
  margin-bottom: 20px;
}

.no-results p {
  color: #7f8c8d;
  font-size: 1.2rem;
}

footer {
  text-align: center;
  margin-top: 60px;
  padding: 20px;
  color: #7f8c8d;
}

@media (max-width: 768px) {
  .controls {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
   .certificate-card {
    width: 100%;
   
    
  }

  .certificate-image{
     width: 100%;
  
  }
  .certificate-image img{
    width: 100%;
    

  }
  .certificate-image2{
       width: 100%;
  
  }
  
  .certificate-image2 img{
    width: 100%;
    
  }
 
 }
</style>